/**
 * StreamOutputUriDTO entity class
 */

/**
 * StreamOutputUriDTOFactory
 * returns StreamOutputUriDTO entity class
 *
 * @class StreamOutputUriDTOFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.StreamOutputUriDTO} class
 *
 * @ngdoc factory
 * @name mwApp.factory:StreamOutputUriDTOFactory
 */
/* @ngInject */
export default function StreamOutputUriDTOFactory (Entity) {
  /* === StreamOutputUriDTO class === */

  /**
   * StreamOutputUriDTO model
   *
   * @class StreamOutputUriDTO
   * @classdesc StreamOutputUriDTO model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @param {Object} [object] - initial object, containing StreamOutputUriDTO entity fields
   * @return {models.StreamOutputUriDTO} StreamOutputUriDTO entity
   */
  function StreamOutputUriDTO () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  StreamOutputUriDTO.prototype = Object.create(Entity.prototype)
  StreamOutputUriDTO.prototype.constructor = StreamOutputUriDTO

  /* === StreamOutputUriDTO instance methods & fields === */

  Object.assign(StreamOutputUriDTO.prototype, {

    /**
     * instance fields
     *
     * @memberof models.StreamOutputUriDTO#
     * @type {Object}
     */
    _fields: {
      uri: String,
      type: String /* SETRIX_OUTPUT_URI_TYPES */
    }
  })

  /**/

  /* === StreamOutputUriDTO static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(StreamOutputUriDTO, Entity)
  StreamOutputUriDTO._name = 'StreamOutputUriDTO'
  StreamOutputUriDTO.init()

  return StreamOutputUriDTO
}
